(function () {
  function loadSlick(cb){
    function loadJS(src,id,onload){
      if(document.getElementById(id)){ onload(); return; }
      var s=document.createElement('script'); s.src=src; s.id=id; s.onload=onload; document.head.appendChild(s);
    }
    function loadCSS(href,id){
      if(document.getElementById(id)) return;
      var l=document.createElement('link'); l.rel='stylesheet'; l.href=href; l.id=id; document.head.appendChild(l);
    }
    loadCSS('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css','slick-css');
    loadJS('https://cdn.jsdelivr.net/npm/jquery@3.6.4/dist/jquery.min.js','jq',function(){
      loadJS('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js','slick-js',cb);
    });
  }

  // Detect Safari
  function isSafari() {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
  }

  // Calculate pixel-based padding for Safari
  function getMobileCenterPadding() {
    if (isSafari()) {
      var padding = Math.round(window.innerWidth * 0.18);
      return padding + 'px';
    }
    return '18%';
  }

  function initSection(root){
    var $ = window.jQuery; if(!$) return;

    var $sections = root ? $(root).find('.products-slider').addBack('.products-slider') : $('.products-slider');
    if(!$sections.length) return;

    $sections.each(function(){
      try {
        var $section = $(this);
        var $wrap     = $section.find('.slider-wrapper');
        var $prevDesk = $section.find('.products-slider__track > .ps-nav--prev');
        var $nextDesk = $section.find('.products-slider__track > .ps-nav--next');
        var $mobPrev  = $section.find('.ps-nav-mob--prev');
        var $mobNext  = $section.find('.ps-nav-mob--next');

        if(!$wrap.length) return;

        if($wrap.hasClass('slick-initialized')) {
          try { $wrap.slick('unslick'); } catch(e){}
        }

        var mobilePadding  = getMobileCenterPadding();
        var hasArrows      = $prevDesk.length > 0 && $nextDesk.length > 0;

        $wrap.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          speed: 350,
          infinite: true,
          cssEase: 'ease',
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: hasArrows,
          prevArrow: hasArrows ? $prevDesk : undefined,
          nextArrow: hasArrows ? $nextDesk : undefined,
          responsive: [
            { breakpoint: 1280, settings: { slidesToShow: 4 } },
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 900,  settings: { slidesToShow: 2 } },
            { breakpoint: 768,  settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: mobilePadding
            }}
          ]
        });

        if($mobPrev.length){
          $mobPrev.off('click.ps').on('click.ps', function(){ $wrap.slick('slickPrev'); });
        }
        if($mobNext.length){
          $mobNext.off('click.ps').on('click.ps', function(){ $wrap.slick('slickNext'); });
        }

      } catch(e) {
        console.warn('Products slider init failed:', e);
      }
    });
  }

  function initAll(){
    var $ = window.jQuery;
    if($ && $.fn && $.fn.slick){
      initSection(null);
    } else {
      // Slick script loaded but hasn't registered on jQuery yet — poll until ready
      var attempts = 0;
      var poll = setInterval(function(){
        var $j = window.jQuery;
        if($j && $j.fn && $j.fn.slick){
          clearInterval(poll);
          initSection(null);
        } else if(++attempts > 50){ // give up after ~2.5s
          clearInterval(poll);
          console.warn('Slick carousel failed to register on jQuery.');
        }
      }, 50);
    }
  }

  loadSlick(initAll);

  // Reinitialize on resize for Safari (to recalculate pixel padding)
  var resizeTimer;
  window.addEventListener('resize', function() {
    if (isSafari() && window.innerWidth <= 768) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initSection(null);
      }, 250);
    }
  });

  document.addEventListener('shopify:section:load',    function(e){ initSection(e.target); });
  document.addEventListener('shopify:section:reorder', function(e){ initSection(e.target); });
  document.addEventListener('shopify:section:unload',  function(e){
    var $ = window.jQuery; if(!$) return;
    var $wrap = $(e.target).find('.slider-wrapper');
    if($wrap.hasClass('slick-initialized')){
      try { $wrap.slick('unslick'); } catch(err){}
    }
  });
})();
